var yearElement = document.getElementById('AGYear');
var monthElement = document.getElementById('AGMonth');
var dayElement = document.getElementById('AGDay');

function injectError(message, targetClass) {
    var errorTemplate = `<div class="validationError error">${message}</div>`;

    // remove old errors
    let elementListRemove = document.getElementsByClassName('validationError');
    for (let item of elementListRemove) {
        item.remove();
    }

    let elementList = document.getElementsByClassName(targetClass);
    for (let item of elementList) {
        //console.log(item);
        item.insertAdjacentHTML('beforeBegin', errorTemplate);
    }
}

function checkAge() {
    let error = false;

    // VALIDATION
    // --------------------

    let countryDD = document.getElementById('Countries');
    let country = countryDD.value;
    let countryName = countryDD.options[countryDD.selectedIndex].text;

    if (isEmptyOrSpaces(country)) {
        injectError(pleaseCompleteCountry, 'Countries');
        error = true;
    }

    let day = document.getElementById('AGDay').value;
    let month = document.getElementById('AGMonth').value;
    let year = document.getElementById('AGYear').value;

    let date = new Date(year, month - 1, day);

    if (isEmptyOrSpaces(day) || isEmptyOrSpaces(month) || isEmptyOrSpaces(year) || date == null) {
        injectError(pleaseCompleteDate, 'select-container-date');
        error = true;
    }

    // API CALL
    // --------------------

    if (!error) {
        let prom = checkAgeWithAPI(country, date);
        prom.then(
            function (result) {
                if (result.success) {
                    
                    var allowed = JSON.parse(result.resultJson);
                    var dateYear = date.getFullYear();
                    if (allowed.alcoholPurchaseProhibited) {
                        if (typeof googleDataLayer !== 'undefined') {
                            googleDataLayer.failedAgeGate(countryName, dateYear, "Blocked by country");
                        }
                        injectError(notAllowedByCountry.replace('%%country%%', countryName), 'select-container-date')
                        return;
                    }
                    if (allowed.ageCheckResult) {
                        if (typeof googleDataLayer !== 'undefined') {
                            googleDataLayer.passedAgeGate(countryName, dateYear);
                        }
                        SetAgeGateCookieAndRedirect(countryName);
                    } else {
                        if (typeof googleDataLayer !== 'undefined') {
                            googleDataLayer.failedAgeGate(countryName, dateYear, "Not old enough");
                        }
                        injectError(notOldEnoughError.replace('%%country%%', countryName).replace('%%purchaseAge%%', allowed.alcoholPurchaseAge), 'select-container-date')
                    }
                }
                else
                {
                    if (typeof googleDataLayer !== 'undefined') {
                        googleDataLayer.failedAgeGate(countryName, dateYear, "API Error");
                    }
                    injectError('Non-success from API', 'select-container-date');
                }
            }
        );
    }
}

// API / Query
// ===========

function checkAgeWithAPI(country, date) {
    //https://dalmore-local.factory73.com/umbraco/surface/API/CheckAgeGate/?country=GB&dateOfBirth=2000-03-02T12:01:19.289Z&brand=Dalmore

    let parameters = new URLSearchParams({
        country: country,
        dateOfBirth: date.toISOString()
    });

    console.log('Parameters : %o', parameters);

    return new Promise(function (resolve, reject) {
        fetch(ageGateUrl + '?' + parameters, {
            method: 'get', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                resolve(response.json());
            })
            .catch(error => {
                console.log('Failed', error);
                reject(error);
            });
    });
}

yearElement.addEventListener('change', function (event) {
    //console.log(event.target); // The clicked element
    daysInMonth();
});
monthElement.addEventListener('change', function (event) {
    //console.log(event.target); // The clicked element
    daysInMonth();
});

function SetAgeGateCookieAndRedirect(country) {
    AgeGateSet(country);   // Scripts.js
    //console.log('Allowed');

    document.getElementById("modal_id").classList.add('hidden');
    document.querySelector("body").classList.remove('overflow--hidden');
}

function daysInMonth() {
    var month = parseInt(monthElement.value);
    var year = parseInt(yearElement.value);

    if (month !== 0 && year !== 0) {
        var days = new Date(year, month, 0).getDate();

        // Remove all
        var first = true;
        for (const option of document.querySelectorAll('#AGDay > option')) {
            if (!first) {	// Leave the day label
                option.remove();
            } else {
                first = false;
            }
        }
        for (let d = 1; d <= days; d++) {
            option = document.createElement("option");
            option.text = d;
            option.value = d;
            dayElement.appendChild(option)
        }

        document.getElementById("AGDay").selectedIndex = 1; 
    } else {
        return 0;
    }
}